@import "../../styles/variables.scss";

.detection-test {
  height: 100%;
  padding: 20px;

  display: flex;
  flex-direction: column;
}

.report {
  .section {
    h1 {
      padding: 12px 0;
      font-size: 18px;
      margin: 12px 0;
      border-bottom: 1px solid #ccc;

      display: flex;
      flex-direction: row;
      align-items: center;
    }

    pre {
      padding: 12px;
      font-family: monospace;
      font-size: 14px;
      line-height: 1.6em;

      background-color: #ddd;
      overflow-x: auto;

      pre {
        padding: 0;
        &.highlighted {
          background-color: #ffd63320;
        }
      }
    }

    img {
      max-width: 100%;
      object-fit: contain;
      margin: 0 auto;
      max-height: 100%;
    }
  }
}
